<template>
  <modal :name="name"
         :adaptive="true"
         height="auto"
         width="680">
    <div class="ut-px-10 ut-pt-12 ut-pb-8">
      <div @click="closeModal()" class="ut-absolute ut-top-0 ut-right-0 ut-mt-2 ut-mr-2 ut-cursor-pointer">
        <svg-loader :name="'icon-open-close'" :width="20" :color-class="'ut-text-neutral-400'"  />
      </div>
        <Prospecting-plug-n-play preSelectedCRM="MyDesktop" />

    </div>
  </modal>
</template>

<script>
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import ProspectingPlugNPlay from '@/components/Prospecting/ProspectingPlugNPlay.vue';

export default {
  name: 'ProspectingReconnectCrmModal',
  components: {
    ProspectingPlugNPlay,
    SvgLoader,
  },
  props: {
    agentId: {
      required: true,
    },
  },
  data() {
    return {
      name: 'prospecting-reconnect-crm-modal',
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  computed: {

  },
  methods: {
    closeModal() {
      this.$modal.hide(this.name);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
